import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { v4 as getUUID } from 'uuid';
import noop from 'lodash/noop';

import Label from '@adsk/bim360-matrix-react-label';
import './_RadioButton.scss';

/**
 * A RadioButton component.
 */
export default class RadioButton extends Component {
  constructor(props) {
    super(props);
    this.uuid = getUUID();
  }

  render() {
    const { className, name, value, checked, onChange, label, children, ...restProps } = this.props;
    const classes = classNames('RadioButton', className);

    return (
      <div className={classes}>
        <input
          type="radio"
          {...restProps}
          className={'RadioButton__radio-input'}
          id={this.uuid}
          name={name}
          value={value}
          checked={checked}
          onChange={e => onChange(e)}
        />
        <Label htmlFor={this.uuid}>
          <span className="RadioButton__radio-button" />
          <div className="RadioButton__label">{label} </div>
        </Label>
        {children}
      </div>
    );
  }
}

RadioButton.defaultProps = {
  checked: false,
  onChange: noop
};

RadioButton.propTypes = {
  /**
   * Custom className for the component
   */
  className: PropTypes.string,
  /**
   * The label text for the Radio button
   */
  label: PropTypes.node.isRequired,
  /**
   * Radio button group name (radio buttons with the same name are handled as a group of radio buttons)
   */
  name: PropTypes.string.isRequired,
  /**
   * Value
   */
  value: PropTypes.string.isRequired,
  /**
   * On Change function
   */
  onChange: PropTypes.func,
  /**
   * Whether the RadioButton is checked
   */
  checked: PropTypes.bool,
  /**
   * Children
   */
  children: PropTypes.node
};
